import { useDispatch, useSelector } from "react-redux";

import { Cards } from "../components/cards";
import { FetchGalleries } from "../redux/gallery";
import { Grid } from "../components/section";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useEffect } from "react";

export const GalleryList = () => {
  const dispatch = useDispatch();
  const { galleries } = useSelector((state) => state.gallery);

  useEffect(() => {
    dispatch(FetchGalleries());
  }, [dispatch]);

  console.log("Galleries:", galleries);
  return (
    <>
      <Grid col="2" as="ul">
        <li>
          {/* The "to" prop is the path we want to navigate to */}
          <Link to="photos">Go to Photos</Link>
          <Container col="2">
            {galleries &&
              galleries
                ?.filter((x, i) => x && i <= 5)
                .map((r) => {
                  const name = r?.fileName?.split("~")[1]?.split(".")[0];
                  const id = r?.fileName?.split("~")[0];
                  return (
                    <Cards
                      version="4"
                      key={id}
                      image={r?.media?.mediaFiles[0]?.url}
                      imageDescription={name}
                    />
                  );
                })}
          </Container>
        </li>
        <li>
          <Link to="videos">Go to Videos</Link>
        </li>
      </Grid>
    </>
  );
};

export default GalleryList;

const Container = styled(Grid)`
  gap: 0;
  margin-top: 2rem;

  img {
    height: 150px;
  }
`;
